export enum DataLayerError {
    trackEvent = 'trackEventError',
    trackT2SEvent = 'trackT2SEventError',
    addVariable = 'addVariableError',
    addVariables = 'addVariablesError',
    showPrivacyCenter = 'showPrivacyCenterError',
    deleteVariable = 'deleteVariableError',
}
